import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import AddPriceListTier from './AdminPriceListsAddTierModal';
import Pricelist from './Pricelist';
import authService from './api-authorization/AuthorizeService';

interface AdminPriceList {
    priceListTier: PriceListTierList[];
    itemList: Item[];
    pricelist: PriceListItem[];
    pricelistDiscount: PriceListDiscountItem[];
    tierDiscount: TierDiscount[];    //for adding a new tier
    customerOptions: GenericList[];
    priceListTierId: string;
    priceListTierTypeId: number;
    chargeCleaningFee: boolean;
    chargeExtraEquipmentFee: boolean;
    loading: boolean;
    pricelistLoading: boolean;
    showAddTier: boolean;
    tierName: string;
    customerId: number;
    systemCompanyId: number;
    readOnly: boolean;
    errors: any;
}

interface PriceListTierList {
    id: number;
    uniqueId: string;   //to cater for customer and tier pricelists
    name: string;
    typeId: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface Item {
    id: number;
    name: string;
    defaultDays: number;
    typeId: number;
    overhireRequired: boolean;
}

interface PriceListItem {
    id: number;
    tierId: number;
    customerId: number;
    customerName: string;
    itemId: number;
    itemTypeId: number;
    hirePeriod: number;
    frequencyId: number;
    locationId: number;
    metreId: number;
    baseDays: number;
    basePrice: number;
    baseMetres: number;
    useBtm: boolean;
    metreRate: number;
    travelAmount: number;
    baseAdditionalHireRate: number;
    additionalHireRate: number;
    extraHourRate: number;
    overhireRequired: boolean;
    statusId: number;
    isDirty: boolean;
}

interface PriceListDiscountItem {
    id: number;
    tierId: number;
    name: string;
    days: string;
    discount: string;
}

interface TierDiscount {
    name: string;
    startDays: number;
    endDays: number;
    discountPercent: number;
}

export class AdminPriceListData extends React.Component<RouteComponentProps<{}>, AdminPriceList> {
    constructor(props: any) {
        super(props);

        this.state = {
            priceListTier: [],
            itemList: [],
            pricelist: [],
            pricelistDiscount: [],
            tierDiscount: [],
            customerOptions: [],
            priceListTierId: "",
            priceListTierTypeId: -1,
            chargeCleaningFee: true,
            chargeExtraEquipmentFee: true,
            loading: true,
            pricelistLoading: false,
            showAddTier: false,
            tierName: "",
            customerId: -1,
            systemCompanyId: 2,
            readOnly: false,
            errors: {}
        }

    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getPricelistData();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    getPricelistData = () => {
        this.getAdminPricelistData();
    }

    async getAdminPricelistData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/PriceList/GetPricelistData?SubId=' + user.sub + '&IsEws=true&IsPumpClean=false&IsEpa=false&IsFencing=false&IsEvent=false', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ systemCompanyId: res.data.systemCompanyId, itemList: res.data.itemList, priceListTier: res.data.priceListTier, customerOptions: res.data.customerOptions, readOnly: res.data.readOnly, loading: false })
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    getPricelist = (id: number, typeId: number) => {
        this.getAdminPricelist(id, typeId);
    }

    async getAdminPricelist(id: number, typeId: number) {
        if (id > 0) {
            const token = await authService.getAccessToken();
            const user = await authService.getUser();
            axios.get('api/PriceList/GetPricelist?SubId=' + user.sub + '&Id=' + id + '&PriceListType=' + typeId, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                var pricelist = res.data.priceList;
                let pricelistItem = this.addBlankRow(id, typeId * 1);
                pricelist.push(pricelistItem);

                this.setState({ pricelist: pricelist, pricelistDiscount: res.data.priceListDiscount, chargeCleaningFee: res.data.chargeCleaningFee, chargeExtraEquipmentFee: res.data.chargeExtraEquipmentFee, pricelistLoading: false })
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            this.setState({ pricelist: [], pricelistDiscount: [], pricelistLoading: false });
        }
    }

    addBlankRow = (id: number, typeId: number) => {
        var tierId = -1;
        var customerId = -1;
        if (typeId === 1) {
            tierId = id;
            
        } else {
            customerId = id;
        }

        let pricelistItem: PriceListItem = {
            id: 0,
            tierId: tierId,
            customerId: customerId,
            customerName: "",
            itemId: -1,
            itemTypeId: 0,
            hirePeriod: 0,
            frequencyId: -1,
            locationId: -1,
            metreId: -1,
            baseDays: 0,
            basePrice: 0,
            baseMetres: 0,
            useBtm: false,
            metreRate: 0,
            travelAmount: 0,
            baseAdditionalHireRate: 0,
            additionalHireRate: 0,
            extraHourRate: 0,
            overhireRequired: true,
            statusId: 1,
            isDirty: false
        };

        return pricelistItem;
    }

    //ADD TIER
    addTier = () => {
        if (this.state.systemCompanyId === 2) {
            this.addNewTier();
        } else {
            this.setState({ showAddTier: true, tierName: "", customerId: -1, tierDiscount: [] });
        }
    }

    async addNewTier() {
        //get default tier discount
        const token = await authService.getAccessToken();
        axios.get('api/PriceList/GetDefaultTierDiscount?SystemCompanyId=' + this.state.systemCompanyId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var discounts = res.data;
            var blankRow = this.addBlankDiscountRow();
            discounts.push(blankRow);

            this.setState({ showAddTier: true, tierName: "", customerId: -1, tierDiscount: discounts });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addBlankDiscountRow = () => {
        var discount: TierDiscount = {
            name: "",
            startDays: 0,
            endDays: 0,
            discountPercent: 0
        };
        return discount;
    }

    hideAddTier = () => {
        this.setState({ showAddTier: false, tierName: "", customerId: -1, tierDiscount: [] });
    }

    updateTierName = (tierName: string) => {
        this.setState({ tierName: tierName });
    }

    updateCustomer = (customerId: number) => {
        this.setState({ customerId: customerId });
    }

    updateTierDiscount = (tierDiscount: TierDiscount[]) => {
        this.setState({ tierDiscount: tierDiscount });
    }

    saveAddTier = (typeId: number) => {
        this.saveAddNewTier(typeId);
    }

    async saveAddNewTier(typeId: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        let pricelistTiers = this.state.priceListTier;
        var discounts = this.state.tierDiscount;
        discounts.pop();

        if (typeId === 1) {
            let saveAddTier = {
                tierName: this.state.tierName,
                discounts: discounts,
                subId: user.sub
            };

            axios.post('api/PriceList/SavePriceListTier', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                    var blankRow = this.addBlankDiscountRow();
                    discounts.push(blankRow);
                    this.setState({ tierDiscount: discounts });
                } else {
                    pricelistTiers.push(res.data);
                    toast.success("Price List Tier Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = this.addBlankRow(res.data.id, 1);
                    pricelist.push(pricelistItem);

                    var chargeCleaning = res.data.chargeCleaningFee;
                    var chargeEquipment = res.data.chargeExtraEquipmentFee;

                    this.setState({ priceListTierId: res.data.uniqueId, priceListTierTypeId: 1, pricelist: pricelist, showAddTier: false, tierName: "", customerId: -1, tierDiscount: [], priceListTier: pricelistTiers, pricelistDiscount: res.data.priceListDiscount, chargeCleaningFee: chargeCleaning, chargeExtraEquipmentFee: chargeEquipment });
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            var customerId = this.state.customerId * 1;
            var customer = this.state.customerOptions.find(c => c.id === customerId);
            let saveAddTier = {
                customerid: customerId,
                customerName: customer?.name,
                isEws: true,
                discounts: discounts,
                subId: user.sub
            };

            axios.post('api/PriceList/SavePricelistCustom', saveAddTier, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    for (var i = 0; i < errors.length; i++) {
                        toast.error(errors[i].content);
                    };
                    var blankRow = this.addBlankDiscountRow();
                    discounts.push(blankRow);
                    this.setState({ tierDiscount: discounts });
                } else {
                    pricelistTiers.push(res.data);
                    toast.success("Price List Custom Saved Successfully");

                    let pricelist: PriceListItem[] = [];
                    let pricelistItem = this.addBlankRow(res.data.id, 2);
                    pricelist.push(pricelistItem);

                    var chargeCleaning = res.data.chargeCleaningFee;
                    var chargeEquipment = res.data.chargeExtraEquipmentFee;

                    this.setState({ priceListTierId: res.data.uniqueId, priceListTierTypeId: 2, pricelist: pricelist, showAddTier: false, tierName: "", customerId: -1, tierDiscount: [], priceListTier: pricelistTiers, pricelistDiscount: res.data.priceListDiscount, chargeCleaningFee: chargeCleaning, chargeExtraEquipmentFee: chargeEquipment });
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    //END ADD TIER

    handleChange = (e: any) => {
        var uniqueId = e.target.value;
        var plId = uniqueId.substring(1) * 1;
        let typeId = 1;

        if (uniqueId != "") {
            let priceListOption = this.state.priceListTier[e.target.selectedIndex - 1];
            if (priceListOption) {
                typeId = priceListOption.typeId;
            }
        }

        let change: any = {};
        change[e.target.name] = uniqueId;
        change["priceListTierTypeId"] = typeId;     //need to know if it is a Tier or a Customer
        change["pricelistLoading"] = true;
        this.setState(change);

        if (uniqueId != "") {
            this.getPricelist(plId, typeId);
        }
    }

    handleCleaningCheckboxChange = (e: any) => {
        this.updateChargeFees(e.target.checked, this.state.chargeExtraEquipmentFee);
    }

    handleEquipmentCheckboxChange = (e: any) => {
        this.updateChargeFees(this.state.chargeCleaningFee, e.target.checked);
    }

    updateChargeFees = async (cleaningFee: boolean, equipmentFee: boolean) => {
        const token = await authService.getAccessToken();

        var id = parseInt(this.state.priceListTierId.substring(1));

        var saveChargeFees = {
            id: id,
            typeId: this.state.priceListTierTypeId,
            cleaningFee: cleaningFee,
            extraEquipmentFee: equipmentFee,
            companyId: this.state.systemCompanyId
        };

        axios.post('api/PriceList/SaveTierChargeFee', saveChargeFees, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Charge Fee Saved Successfully");
                this.setState({ chargeCleaningFee: cleaningFee, chargeExtraEquipmentFee: equipmentFee });
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    updatePricelist = (pricelist: PriceListItem[]) => {
        this.setState({ pricelist: pricelist });
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;
        let items = this.state.pricelist;

        if (items.length === 1) {
            errors["pricelistitems"] = "Please enter at least one item!";
            this.setState({ errors: errors });
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for(var i = 0; i < items.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (items[i].itemId < 1) {
                newErrorString += "Item, ";
                error = true;
            }

            if (!items[i].basePrice || items[i].basePrice <= 0) {
                newErrorString += "Base Price, ";
                error = true;
            }

            if (!items[i].additionalHireRate || items[i].additionalHireRate <= 0) {
                newErrorString += "Additional Hire Rate, ";
                error = true;
            }

            if (this.state.systemCompanyId === 2 && (!items[i].extraHourRate || items[i].extraHourRate <= 0)) {
                newErrorString += "Extra Hour Rate, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
            
        }
        if (error) {
            formIsValid = false;
            errors["pricelistitems"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    submit = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            var changed = this.state.pricelist.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                this.savePricelist(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    async savePricelist(changed: PriceListItem[]) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var savePriceList = {
            priceListItems: changed,
            subId: user.sub
        };

        axios.post('api/PriceList/SavePricelist', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                this.setState({ pricelistLoading: true });
                var id = parseInt(this.state.priceListTierId.substring(1));
                this.getPricelist(id, this.state.priceListTierTypeId);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Price Lists</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let pricelistTiers = this.state.priceListTier;
        let pricelistDicount = this.state.pricelistDiscount;
        
        let addTier = <AddPriceListTier showModal={this.state.showAddTier} tierName={this.state.tierName} customerId={this.state.customerId} tierDiscount={this.state.tierDiscount} customerOptions={this.state.customerOptions} systemCompanyId={this.state.systemCompanyId} hideModal={this.hideAddTier} updateTier={this.updateTierName} updateCustomer={this.updateCustomer} updateTierDiscount={this.updateTierDiscount} saveModal={this.saveAddTier} />

        let id = this.state.priceListTierId === "" ? 0 : parseInt(this.state.priceListTierId.substring(1));
        let pricelist = <Pricelist systemCompanyId={this.state.systemCompanyId} id={id} priceListTierTypeId={this.state.priceListTierTypeId} pricelist={this.state.pricelist} itemList={this.state.itemList} customerOptions={[]} frequencyList={[]} locationList={[]} metresList={[]} isEpa={false} isPumpClean={false} isFencing={false} isFencingCustom={false} isEvent={false} isPriceOnly={false} update={this.updatePricelist} />

        return (
            <form onSubmit={this.submit}>
                <div className="static-modal">
                    {addTier}
                </div>
                <div className="input-group-parent">
                    <label className="input-group" htmlFor="priceListTierId">
                        <span className="label">Tier/Customer</span>
                        <select className="select marginRight10" id="priceListTierId" name="priceListTierId" value={this.state.priceListTierId} onChange={(e) => this.handleChange(e)}>
                            <option hidden defaultValue=""></option>
                            {pricelistTiers.map(tier =>
                                <option key={tier.uniqueId} value={tier.uniqueId}>{tier.name}</option>
                            )};
                        </select>
                        <button className={this.state.readOnly ? "hidden" : "defaultbutton defaultbutton__small"} type="button" onClick={this.addTier}>Add New</button>
                    </label>
                </div>
                <div className={this.state.systemCompanyId == 2 ? "input-group-parent" : "hidden"}>
                    <span>Extended hire period discount rates</span>
                    <table className="pricelist-discount-width">
                        {pricelistDicount.map((item, index) => 
                            <tbody key={index}>
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.days}</td>
                                    <td>{item.discount}</td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
                <div className={this.state.systemCompanyId == 3 && this.state.priceListTierId != "" ? "input-group-parent" : "hidden"}> 
                    <label className="input-group" htmlFor="chargeCleaningFee">
                        <span className="label label-large label--nopadding">Charge Cleaning Fee</span>
                        <input className="checkbox" type="checkbox" id="chargeCleaningFee" name="chargeCleaningFee" checked={this.state.chargeCleaningFee} onChange={(e) => this.handleCleaningCheckboxChange(e)} disabled={this.state.readOnly}></input>
                    </label>
                    <label className="input-group" htmlFor="chargeExtraEquipmentFee">
                        <span className="label label-large label--nopadding">Charge Equipment (table & chairs) Fee</span>
                        <input className="checkbox" type="checkbox" id="chargeExtraEquipmentFee" name="chargeExtraEquipmentFee" checked={this.state.chargeExtraEquipmentFee} onChange={(e) => this.handleEquipmentCheckboxChange(e)} disabled={this.state.readOnly}></input>
                    </label>
                </div>
                <div>
                    <hr></hr>
                </div>
                <div className={this.state.priceListTierId != "" && !this.state.pricelistLoading ? "" : "hidden"}>
                    {pricelist}
                    {this.state.errors["pricelistitems"] ?
                        (this.state.errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                </div>
                <div className={this.state.pricelistLoading ? "" : "hidden"}><p><em>Loading...</em></p></div>
                <div className="marginBottom10">
                    <button className={this.state.readOnly ? "hidden" : "defaultbutton defaultbutton__large"} type="submit" disabled={this.state.pricelistLoading || this.state.priceListTierId === "" ? true : false}>Save</button>
                </div>
            </form>
        );

    }

};